<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("googleBusiness.visibility") }}</div>
        </div>
        <div class="form-content">
            <p class="description">{{ $t("googleBusiness.visibilityDescription") }}</p>
            <a-form-item :label="$t('googleBusiness.visibleToUsers')">
                <a-select
                    mode="multiple"
                    v-model="localChannel.visibility.users"
                    :placeholder="$t('googleBusiness.selectUsers')"
                    style="width: 100%"
                >
                    <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                        {{ user.fullName }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item :label="$t('googleBusiness.visibleToDepartments')">
                <a-select
                    mode="multiple"
                    v-model="localChannel.visibility.departments"
                    :placeholder="$t('googleBusiness.selectDepartments')"
                    style="width: 100%"
                >
                    <a-select-option v-for="dept in departments" :key="dept._id" :value="dept._id">
                        {{ dept.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <div class="form-actions">
                <a-button type="primary" @click="save" :loading="saving">
                    {{ $t("googleBusiness.save") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "Visibility",
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localChannel: _.cloneDeep(this.value),
            saving: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users,
            departments: (state) => state.subject.subjects,
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listUsers: "user/listUsers",
            listSubjects: "subject/listSubjects",
        }),
        async save() {
            this.saving = true;
            try {
                await this.updateChannel({
                    _id: this.localChannel._id,
                    visibility: this.localChannel.visibility,
                });
                this.$message.success(this.$t("googleBusiness.visibilityUpdated"));
                this.$emit("saved");
            } catch (err) {
                this.$message.error(this.$t("googleBusiness.errorUpdatingVisibility"));
            } finally {
                this.saving = false;
            }
        },
    },
    watch: {
        value: {
            handler(newVal) {
                this.localChannel = _.cloneDeep(newVal);
            },
            deep: true,
        },
    },
    mounted() {
        this.listUsers();
        this.listSubjects();
    },
};
</script>

<style lang="scss" scoped>
.tab-detail {
    padding: 20px;

    .header {
        padding-bottom: 15px;
        border-bottom: 1px solid var(--color-border-default);
        margin-bottom: 20px;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }
    }

    .form-content {
        max-width: 500px;

        .description {
            color: var(--color-text-default);
            margin-bottom: 20px;
        }

        .form-actions {
            margin-top: 20px;
        }
    }
}
</style>
